import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Catering from "../../../assets/img/Featured/laptop-catering.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
const HallPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page hallPage">
            <Header />
            <div className="page-header">Golf Course</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Event Hall</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Make every meeting, social event, ceremony or
                    fundraiser unforgettable with Agilysys Sales &
                    Catering. With convenient event booking, menu
                    selection and comprehensive logistics
                    management, attendees will be guaranteed a truly
                    memorable experience.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Event Hall", "Sales & Catering");
                    addFlow("Sales & Catering");
                    navigate("/solutions/sales")
                    }}>
                    <img src={Catering} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Sales & Catering
                    </div>
                    
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default HallPage;